import { SvgStyled } from '../../../components/Global/Atomics/SvgStyled';

const Mail = (props) => {
    return (
        <SvgStyled
            xmlns="http://www.w3.org/2000/svg"
            version="1.1"
            className={props.cssClasses ? `icon ${props.cssClasses}` : 'icon'}
            viewBox="0 0 40 40"
            width={props.size}
            height={props.size}>
            <path fillRule="evenodd" clipRule="evenodd"
                d="M5 11C5 8.79086 6.79086 7 9 7H31C33.2091 7 35 8.79086 35 11V29C35 31.2091 33.2091 33 31 33H29C28.4477 33 28 32.5523 28 32C28 31.4477 28.4477 31 29 31H31C32.1046 31 33 30.1046 33 29V11C33 9.89543 32.1046 9 31 9H9C7.89543 9 7 9.89543 7 11V29C7 30.1046 7.89543 31 9 31H11C11.5523 31 12 31.4477 12 32C12 32.5523 11.5523 33 11 33H9C6.79086 33 5 31.2091 5 29V11ZM22.6644 11.2526C23.0771 11.6195 23.1143 12.2516 22.7474 12.6644L16.2268 20H26C26.3938 20 26.7509 20.2311 26.9122 20.5903C27.0736 20.9496 27.009 21.37 26.7474 21.6644L18.7474 30.6644C18.3805 31.0771 17.7484 31.1143 17.3356 30.7474C16.9229 30.3805 16.8857 29.7484 17.2526 29.3356L23.7732 22H14C13.6062 22 13.2491 21.7689 13.0878 21.4097C12.9264 21.0504 12.991 20.63 13.2526 20.3356L21.2526 11.3356C21.6195 10.9229 22.2516 10.8857 22.6644 11.2526ZM3 37C3 36.4477 3.44772 36 4 36H10.5C11.0523 36 11.5 36.4477 11.5 37C11.5 37.5523 11.0523 38 10.5 38H4C3.44772 38 3 37.5523 3 37ZM28.3723 37C28.3723 36.4477 28.82 36 29.3723 36H36C36.5523 36 37 36.4477 37 37C37 37.5523 36.5523 38 36 38H29.3723C28.82 38 28.3723 37.5523 28.3723 37Z"
                fill={props.color ? props.color : "white"} />
        </SvgStyled>
    );
};

export default Mail;
